import React, { useState, useRef, useEffect } from "react";
import { Image } from "react-bootstrap";
import { LayoutHome } from "../LayoutHome";
import { Text } from "rsuite";
import { useParams } from "react-router-dom";
import { getFirmaConsentimiento } from "../Services/PacientesServices";
import moment from "moment/moment";

export const ConsentHemo = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [anios, setAnios] = useState("");
  const [firma, setFirma] = useState("");
  const [idMedico, setIdMedico] = useState("");
  const [medico, setMedico] = useState("");
  const [firmaDoctor, setFirmaDoctor] = useState("");
  const [testigo1, setTestigo1] = useState("");
  const [firmaTestigo1, setFirmaTestigo1] = useState("");
  const [testigo2, setTestigo2] = useState("");
  const [firmaTestigo2, setFirmaTestigo2] = useState("");
  const [fechaFirma, setFechaFirma] = useState("");
  const { idPaciente, paciente } = useParams();
  const initialized = useRef(false);

  const getFirma = async () => {
    await getFirmaConsentimiento(idNegocio, idPaciente, "ConsentHemo")
      .then((res) => {
        setFirma(res.firmaPac);
        setIdMedico(res.idMedico);
        setMedico(res.medico);
        setAnios(res.anios);
        setFirmaDoctor(res.firmaDr);
        setTestigo1(res.testigo1);
        setFirmaTestigo1(res.firmaTestigo1);
        setTestigo2(res.testigo2);
        setFirmaTestigo2(res.firmaTestigo2);
        setFechaFirma(res.fechaFirma);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getFirma();
    }
  }, []);

  return (
    <div>
      <title>Consentimiento de Hemodiálisis</title>
      <Image
        src={`/Images/Negocios/${idNegocio}/cornerImageHoja.png`}
        style={{
          width: "450px",
          position: "absolute",
          right: "0%",
          top: "0%",
          zIndex: "-1",
        }}
      />
      <div
        style={{
          marginLeft: "200px",
          marginTop: "50px",
          marginRight: "200px",
          marginBottom: "50px",
        }}
      >
        <div className="row mb-4">
          <div className="col-lg-3 col-md-4 col-sm-3">
            <Image
              src={`/Images/Negocios/${idNegocio}/Logo.png`}
              height={"80ox"}
            />
          </div>
          <div className="text-center col-lg-6 col-md-6 col-sm-6">
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            <Text>
              CONSENTIMIENTO INFORMADO DE LA ELECCION Y RBALIZACIÓN DE TÉCNICA
              DE DIÁLISIS
            </Text>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-3"></div>
        </div>
        <div className="row mb-3">
          <div className="col" style={{ textAlign: "justify" }}>
            Estimado/a paciente, su médico le ha diagnosticado una enfermedad
            llamada Insuficiencia Renal Crónica Terminal, esto significa que sus
            riñones no realizan su función eficazmente de forma irreversible.
            Como consecuencia no se depura la sangre de sustancias peligrosas
            para la vida, ni se producen otras imprescindibles. Como puede
            comprender no es posible vivir sin un órgano que desarrolla todas
            estas funciones tan importantes.
          </div>
        </div>
        <div className="row mb-3">
          <div className="col" style={{ textAlign: "justify" }}>
            Por este motivo su médico cree que usted debe iniciar un tratamiento
            que se conoce con el nombre de <b>DIÁLISIS</b>. La diálisis es una
            técnica que intenta suplir, aunque solo lo hace parcialmente, alguna
            de las funciones de sus riñones y excepto el transplante, no existe
            ninguna alternativa para conseguir los mismos fines. Aunque la
            diálisis no suple totalmente la función de sus riñones puede
            proporcionarle una calidad de vida aceptable. En nuestro medio se
            obtiene una supervivencia prolongada de los pacientes en diálisis,
            que depende en gran medida de la edad y de las enfermedades
            asociadas.
          </div>
        </div>
        <div className="row mb-3">
          <div className="col" style={{ textAlign: "justify" }}>
            La diálisis es el tratamiento definitivo para los pacientes que en
            virtud de sus características personales no pueden recibir un
            transplante de riñón, pero solo es un tratamiento «puente» en
            aquellos pacientes que pueden ser incluidos en la «Lista de
            Transplante» de donante cadáver o tengan un riñón procedente de
            donante vivo (familiar, esposos, etc.). Existen dos formas de
            Diálisis: la hemodiálisis y la diálisis peritoneal.
          </div>
        </div>

        <div className="row mb-3">
          <div className="col" style={{ textAlign: "justify" }}>
            La{" "}
            <b>
              Hemodiálisis, que es el tratamiento de diálisis al cual usted va a
              estar sometido en esta unidad,
            </b>{" "}
            se basa en el paso de la sangre de un filtro que actúa de colador
            sin dejar pasar células ni sustancias grandes. Normalmente la
            hemodiálisis precisa de 3 a 4 horas tres veces a la semana y se hace
            en el Hospital o en un Centro de diálisis extra hospitalario. Cuando
            se precisara diálisis de urgencia es necesario la colocación de un
            catéter mahukar o permacath en una vena central. Cuando la necesidad
            de hemodiálisis es programada con anticipación se realiza una
            fistula arterio venosa que se utilizan como acceso vascular.
          </div>
        </div>

        <div className="row mb-3">
          <div className="col" style={{ textAlign: "justify" }}>
            La Hemodiálisis suele ser bien tolerada aunque ocasionalmente pueden
            aparecer efectos secundarios: algunos frecuentes pero poco graves,
            como náuseas, vómitos, dolor de cabeza, hipotensión, calambres,
            hematomas o pequeña pérdidas de sangre por los puntos de punción o
            por rotura del dializador. Y otros muy poco frecuentes per más
            graves como rotura de globulos rojos de la sangre (hemólisis),
            reacciones alérgicas severas, alteraciones cardiacas como arritmias,
            angina de pecho, o accidentes cerebro-vasculares. Estas últimas
            podrían llegar a poner en peligro su vida.
          </div>
        </div>

        <div className="row mb-3">
          <div className="col" style={{ textAlign: "justify" }}>
            <b>Diálisis Peritoneal:</b> Para la depuración de la sangre se
            utilizan en este caso las prioridades del peritoneo (una membrana
            que está en el abdomen y que normalmente recubre los intestinos).
            Esta membrana hace la función de filtro. La técnica consiste en
            introducir un liquido especial en el abdomen que permanece durante
            un tiempo para que pasen de la sangre al líquido el exceso de agua y
            de sustancias indeseables. El líquido se renueva periódicamente, 3-4
            veces/día en la forma manual (Diálisis Peritoneal Continua
            Ambulatoria) y de forma automática durante la noche (Diálisis
            Peritoneal Automática con máquina). Para la entrada y salida del
            líquido hay que colocar previamente en la cavidad peritoneal un tubo
            flexible. La diálisis peritoneal es sencilla de realizar, puede
            aprenderla facilmente en pocos días y la puede hacer usted mismo en
            su domicilio. Esta técnica tiene una buena tolerancia aunque puede
            haber también algunas complicaciones leves como son: digestiones
            pesadas, estreñimiento, dolor de espalda, dolor abdominal a la
            entrada o salida del líquido o hernias. Complicaciones menos
            frecuentes pero más grave de esta técnica son las infecciones:
            Infección del orificio del catéter y Peritonitis (infección de la
            cavidad peritoneal), aunque son controlables en la mayoría de los
            casos con tratamiento y sin abandonar la técnica. Aunque en algún
            caso muy excepcional pudiera amenazar su vida. Algunas peritonitis
            excepcionalmente grave o el deterioro de la función del peritoneo
            pueden hacer necesaria la suspensión de la técnica y su inclusión en
            otro tratamiento alternativo como la hemodiálisis.
          </div>
        </div>

        <br></br>
        <br></br>

        <div className="row mb-4">
          <div className="col">
            <b>
              <h5>
                Declaraciones y Firmas del Médico Nefrólogo responsable de la
                unidad y/o en turno, así como del paciente sometido a la técnica
                de hemodiálisis.
              </h5>
            </b>
          </div>
        </div>

        <br></br>
        <br></br>

        <div className="row mb-2">
          <div className="col" style={{ textAlign: "justify" }}>
            <table width={"100%"} style={{ width: "100%" }}>
              <thead>
                <tr>
                  <td>Yo, (paciente)</td>
                  <td style={{ width: "50%", borderBottom: "solid 1px" }}>
                    {paciente}
                  </td>
                  <td>de</td>
                  <td
                    style={{
                      width: "10%",
                      textAlign: "center",
                      borderBottom: "solid 1px",
                    }}
                  >
                    {anios}
                  </td>
                  <td style={{ width: "30%", textAlign: "center" }}>
                    años he sido informado
                  </td>
                </tr>
                <tr style={{ height: "20px" }}>
                  <td colSpan={5}></td>
                </tr>
                <tr>
                  <td style={{ width: "15%" }}>por el médico</td>
                  <td style={{ width: "40%", borderBottom: "solid 1px" }}>
                    {medico}
                  </td>
                  <td colSpan={3} style={{ textAlign: "center" }}>
                    y me ha explicado satisfactoriamente
                  </td>
                </tr>
                <tr>
                  <td colSpan={5}>
                    los beneficios y riesgos de la realización de la
                    hemodiálisis, así mismo de las alternativas del tratamiento
                    dialítico con su eficacia y efectos secundarios, y de las
                    posibles consecuencias que tiene el no realizarme la
                    terapia. Conozco la información contenida en este documento
                    y se me ha permitido hacer las preguntas que he estimado
                    oportunas. He comprendido todo lo anterior y doy mi
                    consentimiento para iniciar y/o continuar con Hemodiálisis
                    en la unidad de
                  </td>
                </tr>
                <tr>
                  <td colSpan={5} style={{ height: "30px" }}></td>
                </tr>
                <tr>
                  <td style={{ width: "18%" }}>UNEFRO con fecha:</td>
                  <td colSpan={4} style={{ borderBottom: "dashed 1px" }}>
                    {moment(fechaFirma).format("LL")}
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </div>
        <br></br>

        <div className="row mb-2">
          <div className="col" style={{ textAlign: "justify" }}>
            Puedo retirar este consentimiento cuando lo desee y sin perjuicio de
            mi cuidado médico posterior.
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <br></br>
            <br></br>
            <br></br>
            Firma del paciente y/o tutor legal
          </div>
          <div
            className="col-lg-4 col-md-4 col-sm-4"
            style={{ borderBottom: "solid 1px" }}
          >
            <img
              src={`Unidades/${idNegocio}/Expedientes/Pacientes/${idPaciente}/Consentimientos/${firma}`}
              alt="signature"
              style={{
                height: "100px",
                zIndex: "-1",
              }}
            />
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1">
            <br></br>
            <br></br>
            <br></br>
            Fecha:
          </div>
          <div
            className="col-lg-3 col-md-3 col-sm-3"
            style={{ borderBottom: "solid 1px" }}
          >
            <br></br>
            <br></br>
            <br></br>
            {moment(fechaFirma).format("LL")}
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-lg-3 col-md-3 col-sm-3">
            <br></br>
            <br></br>
            <br></br>
            Firma testigo 1
          </div>
          <div
            className="col-lg-3 col-md-3 col-sm-3"
            style={{ borderBottom: "dashed 1px" }}
          >
            <img
              src={`Unidades/${idNegocio}/Expedientes/Pacientes/${idPaciente}/Consentimientos/${firmaTestigo1}`}
              alt="signature"
              style={{
                height: "100px",
                zIndex: "-1",
              }}
            />
          </div>
          <div className="col-lg-3 col-md-3 col-sm-3">
            <br></br>
            <br></br>
            <br></br>
            Firma testigo 2
          </div>
          <div
            className="col-lg-3 col-md-3 col-sm-3"
            style={{ borderBottom: "dashed 1px" }}
          >
            {firmaTestigo2 !== "" ? (
              <img
                src={`Unidades/${idNegocio}/Expedientes/Pacientes/${idPaciente}/Consentimientos/${firmaTestigo2}`}
                alt="signature"
                style={{
                  height: "100px",
                  zIndex: "-1",
                }}
              />
            ) : (
              ""
            )}
          </div>
        </div>

        <br></br>
        <div className="row mb-2">
          <div className="col" style={{ textAlign: "justify " }}>
            <table width={"100%"} style={{ width: "100%" }}>
              <thead>
                <tr>
                  <td>
                    <b>Yo, (médico)</b>
                  </td>
                  <td
                    style={{
                      width: "50%",
                      borderBottom: "solid 1px",
                      textAlign: "center",
                    }}
                  >
                    {medico}
                  </td>
                  <td>he informado a este paciente y/o tutor legal o</td>
                </tr>
                <tr>
                  <td colSpan={3}>
                    familiar, del propósito y naturaleza del tratamiento
                    dialítico así como de sus beneficios, riesgos y alternativas
                    del mismo.
                  </td>
                </tr>
              </thead>
            </table>
          </div>
        </div>

        <br></br>
        <br></br>
        <div className="row">
          <div
            className="text-center col-lg-4 col-md-4 col-sm-4"
            style={{ fontWeight: "bold" }}
          >
            {firmaDoctor !== "" ? (
              <img
                src={`Unidades/${idNegocio}/Medicos/${idMedico}/${firmaDoctor}`}
                alt="signature"
                style={{
                  height: "150px",
                  zIndex: "-1",
                }}
              />
            ) : (
              ""
            )}
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">&nbsp;</div>
          <div className="text-center col-lg-4 col-md-4 col-sm-4">
            <br></br>
            <br></br>
            <br></br>
            <br></br>
            {moment(fechaFirma).format("LL")}
          </div>
        </div>
        <div className="row mb-2">
          <div
            className="text-center col-lg-4 col-md-4 col-sm-4"
            style={{ borderTopStyle: "solid", borderWidth: "thin" }}
          >
            Firma del médico
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">&nbsp;</div>
          <div
            className="text-center col-lg-4 col-md-4 col-sm-4"
            style={{ borderTopStyle: "solid", borderWidth: "thin" }}
          >
            Fecha
          </div>
        </div>
      </div>
    </div>
  );
};
